var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecurringIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "----\\u21B3-Sell---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-2-/-RMD-with-recurring",
    transform: "translate(-1168.000000, -184.000000)",
    stroke: "#05C3DE",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(130.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1039.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    points: "0.375 5.517975 2.46525 8.631225 4.869 5.752725"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "17.3049 8.744325 15.2154 5.631075 12.8109 8.509575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875,5.65935 C15.813,8.96535 13.48275,12.20535 10.30575,12.95535 C8.09025,13.4796 5.86875,12.7761 4.35825,11.28735",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.468625,8.612475 C1.483875,4.950225 3.946125,1.356975 7.372125,0.547725 C9.739125,-0.012525 12.109125,0.826725 13.615875,2.528475",
    id: "Stroke-7"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringIcon);
export default __webpack_public_path__ + "static/media/recurring-icon.f9daf521b91ad0a70bb7c47607ebc079.svg";
export { ForwardRef as ReactComponent };